module.exports = __webpack_public_path__ + "media/entities/35-364651b0.png";